import './StaticPageLoader.scss'

import React from 'react'

import LoaderComponent from '../LoaderCompoment/LoaderComponent'

const StaticPageLoader = () => {
  return (
    <div className="static-loader">
      <div className="header"></div>
      <div className="loader">
        <LoaderComponent />
      </div>
    </div>
  )
}

export default StaticPageLoader
